import { FC, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./home.module.scss";
import CountUp from "react-countup";
import useRWD from "../../componsnts/hooks/useRWD";
import { DeviceType } from "../../componsnts/hooks/useRWD";
import CustomModal from "../../componsnts/common/registerModal/modal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ConstomSlider from "../../componsnts/common/slider/signUp-slider/signUp-slider";
import WhyCardSlider from "../../componsnts/common/slider/why-card-slider/why-card";
import CollectiveSlider from "../../componsnts/common/slider/collective/collective";
import ScrollToTop from "../../componsnts/common/scroll-to-top/scroll-to-top";
import SectionOne from "../../componsnts/common/power-source-data/sectionOne";
import SectionTitle from "../../componsnts/common/sectionTitle/sectionTitle";
import ContactForm from "../../componsnts/common/contactForm/contactForm";
const Home: FC = () => {
  const device = useRWD();
  const sliderRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const [scrollYNum, setScrollYNum] = useState<number>(700);
  const navigate = useNavigate()

  const dataItem: any[] = [
    {
      moduleName: "在售能量",
      number: "100000000",
      imagePath: "/assets/images/home/power-source/kwh.svg",
    },
    {
      moduleName: "總會員數",
      number: "50",
      imagePath: "/assets/images/home/power-source/totalMember.svg",
      content: "名會員",
    },
    {
      moduleName: "刊登中預購用戶",
      number: "15",
      imagePath: "/assets/images/home/power-source/user.svg",
      content: "名會員",
    },
    {
      moduleName: "媒合率",
      number: "98",
      imagePath: "/assets/images/home/power-source/checked.svg",
      content: "%",
    },
    {
      moduleName: "相較躉售效益",
      number: "10",
      imagePath: "/assets/images/home/power-source/benifit.svg",
      content: "%",
    },
  ];

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const elementId = hash.substring(1);
      const element = document.getElementById(elementId);

      if (element) {
        // 使用 setTimeout 延遲滾動，確保元素渲染完成
        setTimeout(() => {
          let offsetTop = element.getBoundingClientRect().top + window.scrollY;

          if (element.id === "constomSlider") {
            offsetTop -= 400;
          } else if (element.id === "contactUs") {
            offsetTop -= 50;
          }

          window.scrollTo({ top: offsetTop, behavior: "smooth" });

        }, 1);
      }
    }
  }, [location]);

  const handleResize = () => {
    if (window.innerWidth < 576) {
      setScrollYNum(180);
    } else if (window.innerWidth < 768) {
      setScrollYNum(380);
    } else {
      setScrollYNum(400);
    }
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <div className={`${styles["home-box"]} container-fluid`}>
        <div className="col-lg-12 ">
          <div className="banner">
            <div className="container">
              <div
                data-aos="fade-down"
                data-aos-duration="1000"
                data-aos-once="false"
                className="title_container"
              >
                <p className="title">大創電力</p>
                <p className="subTitle">環境永續不再是口號</p>
                <p className="subTitle">綠電不再有距離</p>
              </div>

              <div className="desc_container">
                <p className="desc_content">
                  我們公開價格，降低了使用綠電的距離感
                </p>
                <p className="desc_content">買綠電不再只是大企業的專利</p>
                <p className="desc_content">
                  愛護地球 踏在這塊沃土上的我們都能盡一份心
                </p>
              </div>
            </div>

            <div className="banner_bottom_sec">
              <div className="greenhouse_box container">
                <div className="greenhouse_title_box">
                  <div className="greenhouse_content">
                    RENEWABLE
                    <span className="greenhouse_plaform">綠電交易平台</span>
                  </div>
                  <div className="greenhouse_content">ENERGY TRADING</div>
                </div>
              </div>
            </div>
          </div>

          <div className="constomSlider" id="constomSlider" ref={sliderRef}>
            <ConstomSlider />
          </div>

          <div className="power_source_sec">
            <div
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-once="false"
              className="power_source_title"
            >
              我們充沛的電力來源
            </div>

            <SectionOne></SectionOne>

            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="power_source_data_box ">
                    {dataItem.map((item, index) => (
                      <div className="card_container" key={index}>
                        <div className="data_card">
                          {index === 4 ? (
                            <img
                              className="power_source_img mt-2"
                              src={item.imagePath}
                              alt={item.moduleName}
                            />
                          ) : (
                            <img
                              className="power_source_img"
                              src={item.imagePath}
                              alt={item.moduleName}
                            />
                          )}
                          <div className="data_content">{item.moduleName}</div>
                          {index === 0 ? (
                            <div className="data_number_sm">
                              <CountUp
                                end={item.number}
                                duration={4}
                                separator=","
                                enableScrollSpy={true}
                                scrollSpyOnce={true}
                              />
                              <div className="data_sub_content">kwh</div>
                            </div>
                          ) : index === 1 ? (
                            <>
                              <div className="data_number">
                                <CountUp
                                  end={item.number}
                                  duration={4}
                                  enableScrollSpy={true}
                                  scrollSpyOnce={true}
                                />
                                <span className="data_sub_content">
                                  {item.content}
                                </span>
                              </div>
                            </>
                          ) : index === 4 ? (
                            <div className="index4_box">
                              <div className="front">&gt;</div>
                              <div className="data_number">
                                <CountUp
                                  end={item.number}
                                  duration={4}
                                  enableScrollSpy={true}
                                  scrollSpyOnce={true}
                                />
                                <span className="data_sub_content">
                                  {item.content}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="data_number">
                              <CountUp
                                end={item.number}
                                duration={4}
                                enableScrollSpy={true}
                                scrollSpyOnce={true}
                              />
                              <span className="data_sub_content">
                                {item.content}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="reason_why_sec ">
            <div className="reason_why_title_box">
              <SectionTitle
                title="為什麼要選大創"
                titleColor="#fff"
                subTitle="ADVANTAGES"
                subTitleColor="rgba(0, 149, 217, 0.50)"
                backgroundColor="#0077AE"
                breadcrumbs={false}
              />
            </div>

            <div className="the_reason_box">
              <WhyCardSlider></WhyCardSlider>
            </div>
            <div className="bg_dark_gray"></div>
          </div>

          <div className="contact_sec" id="contactUs">
            {device === DeviceType.PC && (
              <img className="title_bg" src="/assets/images/modal/contactForm_bg.png" alt="" />
            )}
            <div
              className="contact_title_container subTitle"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-once="false"
            >
              CONTACT
              <div className="contact_title">聯絡大創</div>
            </div>

          </div>
          <div className="contact_bg_box">
            <div className="form_box">
              <ContactForm></ContactForm>
            </div>
            {device === DeviceType.PC && (
              <img className="bg_img" src="/assets/images/home/contact/background.png" alt="background" />
            )}

          </div>

          {device !== DeviceType.PC && (
            <div className="divider"></div>
          )}

          <div className="cooperate_sec">
            <div className="container">
              <div className="col-12 cooperate_box">
                <div className="collective">
                  <CollectiveSlider></CollectiveSlider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row">
          <div className="col-lg-12">
            <div className="banner">
              <img
                className="bannerImg_1"
                src="/assets/images/banner/banner-1.jpg"
                alt="Banner-1"
              ></img>
            </div>
          </div>
        </div> */}

      {/* ----------------ＭＯＤＡＬ　ＳＴＡＲＴ------------------ */}
      <ScrollToTop></ScrollToTop>
    </>
  );
};

export default Home;
